<template>
  <!-- 收銀台 -->
  <div v-if="$store.state.user.isCheckoutCounterBCPayActive" class="cc-frame">
    <div class="cc-container">
      <h1 class="cc-title-main">
        <span class="import-amount fw_700">
          {{ $t('Bao.checkout_counter_title1', { value: floatPaymentAmount, symbol: queryParams.payment_token }) }}
        </span>
      </h1>
      <h2 class="cc-title-secondary">
        <span class="get-amount fw_700">
          {{ $t('Bao.checkout_counter_title3', { value: intInvoiceAmount, symbol: queryParams.invoice_currency }) }}
        </span>
      </h2>
      <div class="cc-qr-input-group">
        <input type="text" class="qr-input-control" readonly="" :value="queryParams.payment_address">
        <button
          id="button-addon2"
          class="btn btn-copy-qr"
          type="button"
          @click="copyText(queryParams.payment_address)"
        >
          <img :src="$getThemeImagePath('icon-copy-2.png')" alt="">
        </button>
      </div>
      <div class="qr-pic-box">
        <qrcode-vue :value="queryParams.payment_address" :size="100" />
      </div>
      <div class="countdown-text">
        {{ $t('Bao.checkout_counter_time') }}
        <span v-if="timeLeft > 0" class="countdown-time text-color-warning fw_700"> {{ formattedTime }} </span>
      </div>
      <div class="cc-note-frame">
        <h3 class="list-title">
          {{ $t('Bao.checkout_counter_conditions') }}
        </h3>
        <ol class="list-type-decimal ">
          <li v-if="queryParams.payment_token === 'USDTをTRC-20'">
            <span class="text-color-warning fw_700">{{ $t('Bao.checkout_usdtTRC') }}</span>
          </li>
          <li v-if="queryParams.payment_token === 'USDTをERC20'">
            <span class="text-color-warning fw_700">{{ $t('Bao.checkout_usdtERC') }}</span>
          </li>
          <li>{{ $t('Bao.checkout_counter_conditions6') }}</li>
          <!-- <li>{{ $t('Bao.checkout_counter_conditions7') }}</li> -->
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import { copyText } from '@/utils/tool'
import qrcodeVue from 'qrcode.vue'

function getQueryParams(url) {
  const params = new URLSearchParams(new URL(url).search)
  const result = {}
  for (const [key, value] of params.entries()) {
    result[key] = value
  }
  return result
}
export default {
  name: 'CheckoutCounter',
  components: {
    'qrcode-vue': qrcodeVue
  },
  data() {
    return {
      queryParams: {},
      paymentAmount: 0,
      invoiceAmount: 0,
      expired_at: 0,
      timer: null,
      timeLeft: 0
    }
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.timeLeft / 60)
      const seconds = this.timeLeft % 60
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },
    floatPaymentAmount() {
      const floatNum = Math.floor(this.paymentAmount * 10000) / 10000
      return floatNum
    },
    intInvoiceAmount() {
      const floatNum = Math.floor(this.invoiceAmount)
      return floatNum
    }
  },
  created() {
    this.queryParams = getQueryParams(window.location.href)
    const params = new URLSearchParams(window.location.search)
    this.paymentAmount = params.get('payment_amount')
    this.invoiceAmount = params.get('invoice_amount')
    this.expired_at = params.get('expired_at')
    const currentTimeStamp = Math.floor(Date.now() / 1000)
    this.timeLeft = Math.floor(this.expired_at - currentTimeStamp)
    this.$store.commit('SET_CHECKOUT_COUNTER_BCPAY_OPEN', true)
  },
  mounted() {
    this.startCountdown()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    copyText(msg) {
      copyText(msg, this.promotion_url)
    },
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--
        } else {
          clearInterval(this.timer)
        }
      }, 1000)
    }
  }
}
</script>
